// ----------------------------------------------------------------------
// <copyright file="Izenda.SynergyRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// remove lodash add to global
_ && _.noConflict();

import '../locales/Izenda.Locales';
import 'share/utils/polyfill';
import 'share/errorHandling/Izenda.BlueBirdErrorHandling';
import 'bootstrap';
import '../static/scss/Izenda.Synergy.scss';

import 'share/components/charting/highcharts/Izenda.HighchartVizEngineRegistration';
import 'modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ReportPartConfigurationRegistration';

import version from './api/Izenda.Version';
import components from './api/Izenda.Components';
import authenApi from './api/Izenda.AuthenApi';
import configApi from './api/Izenda.ConfigApi';
import renderApi from './api/Izenda.RenderApi';
import jsFormatApi from './api/Izenda.JsFormatApi';
import reportPartApi from './api/Izenda.ReportPartApi';
import propertyEditorApi from './api/Izenda.PropertyEditorApi';
import fieldContainerApi from './api/Izenda.FieldContainerApi';
import visualizationApi from './api/Izenda.VisualizationApi';
import classProviderApi from './api/Izenda.ClassProviderApi';

import { assignAll } from 'lodash/fp';
/**
 * The main Synergy UI object that expose to outside of library.
 */
export default assignAll([
  version,
  components,
  authenApi,
  configApi,
  renderApi,
  jsFormatApi,
  reportPartApi,
  propertyEditorApi,
  fieldContainerApi,
  visualizationApi,
  classProviderApi
]);



// WEBPACK FOOTER //
// ./ui/Izenda.SynergyRoot.js